import { render } from "./LoginPage.vue?vue&type=template&id=3d88fa22"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"
script.render = render

export default script